// projects/humanresources-payroll/src/assets/i18n/*/hr-pay-additional-pay.json
export class HrPayAdditionalPayKey {
    private static readonly keyPrefix = 'hrPayAdditionalPay';
    public static pageHeader = `${HrPayAdditionalPayKey.keyPrefix}.pageHeader`;
    public static blockage = `${HrPayAdditionalPayKey.keyPrefix}.blockage`;
    public static active = `${HrPayAdditionalPayKey.keyPrefix}.active`;
    public static wageCode = `${HrPayAdditionalPayKey.keyPrefix}.wageCode`;
    public static wageName = `${HrPayAdditionalPayKey.keyPrefix}.wageName`;
    public static wageType = `${HrPayAdditionalPayKey.keyPrefix}.wageType`;
    public static payrollName = `${HrPayAdditionalPayKey.keyPrefix}.payrollName`;
    public static additionalPaymentDate = `${HrPayAdditionalPayKey.keyPrefix}.additionalPaymentDate`;
    public static emptyStateMainTitle = `${HrPayAdditionalPayKey.keyPrefix}.emptyStateMainTitle`;
    public static emptyStateSubtitle = `${HrPayAdditionalPayKey.keyPrefix}.emptyStateSubtitle`;
}
